import {ENDPOINT} from './path'

/**
 * Returns an array of strings representing the file names for each service branch user's
 * configuration. The file names are in the format 'SR00X' where X is a number
 * indicating the configuration.
 *
 * @returns {string[]} An array of file names.
 */
const getServiceBranchFileNames = (): string[] => {
    // Initialize an array of file names with 'BR001' repeated 64 times
    const fileNames: string[] = new Array(64).fill('DefaultServiceMenus')

    // Configuration 1: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[59] = 'SR001'
    // Configuration 2: Member status: true, Admin status: true, coLoader status: false,
    // booking: false, rating: true, allocation: true
    fileNames[51] = 'SR002'
    // Configuration 3: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: false, allocation: true
    fileNames[43] = 'SR003'
    // Configuration 4: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: false
    fileNames[27] = 'SR004'
    // Configuration 5: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: false
    fileNames[3] = 'SR005'
    // Configuration 6: Member status: true, Admin status: false, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[57] = 'SR006'
    // Configuration 7: Member status: false, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[58] = 'SR007'
    // Configuration 8: Member status: false, Admin status: false, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[56] = 'SR008'
    return fileNames
}
/**
 * Returns an array of strings representing the file names for each branch user's
 * configuration. The file names are in the format 'BR00X' where X is a number
 * indicating the configuration.
 *
 * @returns {string[]} An array of file names.
 */
const getBranchFileNames = (): string[] => {
    // Initialize an array of file names with 'BR001' repeated 64 times
    const fileNames: string[] = new Array(64).fill('DefaultBranchMenus')

    // Configuration 1: Member status: true, Admin status: false, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[57] = 'BR001'
    // Configuration 2: Member status: true, Admin status: false, coLoader status: false,
    // booking: false, rating: true, allocation: true
    fileNames[49] = 'BR002'
    // Configuration 3: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: false, allocation: true
    fileNames[43] = 'BR003'
    // Configuration 4: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: false
    fileNames[27] = 'BR004'
    // Configuration 5: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: false
    fileNames[3] = 'BR005'
    // Configuration 6: Member status: true, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[59] = 'BR006'
    // Configuration 7: Member status: true, Admin status: true, coLoader status: false,
    // booking: false, rating: true, allocation: true
    fileNames[51] = 'BR007'
    // Configuration 8: Member status: false, Admin status: true, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[58] = 'BR008'
    // Configuration 9: Member status: false, Admin status: false, coLoader status: false,
    // booking: true, rating: true, allocation: true
    fileNames[56] = 'BR009'
    // Configuration 10: Member status: true, Admin status: false, coLoader status: false,
    // booking: true, rating: true, allocation: false
    fileNames[25] = 'BR011'
    // Configuration 10: When coLoader status is enabled
    const coLoaderEnabledIndexes = [
        4, 5, 6, 7, 12, 13, 14, 15, 20, 21, 22, 23, 28, 29, 30, 31, 36, 37, 38, 39, 44, 45, 46, 47, 52, 53, 54, 55, 60,
        61, 62, 63
    ]
    coLoaderEnabledIndexes.forEach((index) => {
        fileNames[index] = 'BR010'
    })
    return fileNames
}

/**
 * Returns an array of strings representing the file names for each carrier
 * user's configuration. The file names are in the format 'CR00X' where X is
 * a number indicating the configuration.
 *
 * @returns {string[]} An array of file names.
 */
const getCarrierFileNames = (): string[] => {
    // Initialize an array of file names with 'CR001' repeated 32 times
    const fileNames: string[] = new Array(32).fill('DefaultCarrierMenus')

    // Configuration 1: Admin status: true, level of admin status: true,
    // GSA status: true, allocation: true, rating: true
    fileNames[31] = 'CR001'
    // Configuration 2: Admin status: true, level of admin status: true,
    // GSA status: true, allocation: false, rating: true
    fileNames[23] = 'CR002'
    // Configuration 3: Admin status: true, level of admin status: true,
    // GSA status: true, allocation: true, rating: false
    fileNames[15] = 'CR003'
    // Configuration 4: Admin status: true, level of admin status: true,
    // GSA status: true, allocation: false, rating: false
    fileNames[7] = 'CR004'
    // Configuration 5: Admin status: true, level of admin status: false,
    // GSA status: true, allocation: true, rating: true
    fileNames[29] = 'CR005'
    // Configuration 6: Admin status: true, level of admin status: false,
    // GSA status: true, allocation: false, rating: true
    fileNames[21] = 'CR006'
    // Configuration 7: Admin status: true, level of admin status: false,
    // GSA status: true, allocation: true, rating: false
    fileNames[13] = 'CR007'
    // Configuration 8: Admin status: true, level of admin status: false,
    // GSA status: true, allocation: false, rating: false
    fileNames[5] = 'CR008'
    // Configuration 9: When GSA status: false
    const gsaDisabledIndexes = [0, 1, 2, 3, 8, 9, 10, 11, 16, 17, 18, 19, 24, 25, 26, 27]
    gsaDisabledIndexes.forEach((index) => {
        fileNames[index] = 'CR009'
    })
    // Configuration 10: Admin status: false, level of admin status: true,
    // GSA status: true, allocation: true, rating: true
    fileNames[30] = 'CR010'
    // Configuration 11: Admin status: false, level of admin status: true,
    // GSA status: true, allocation: false, rating: true
    fileNames[22] = 'CR011'
    // Configuration 12: Admin status: false, level of admin status: true,
    // GSA status: true, allocation: true, rating: false
    fileNames[14] = 'CR012'
    // Configuration 13: Admin status: false, level of admin status: true,
    // GSA status: true, allocation: false, rating: false
    fileNames[6] = 'CR013'
    // Configuration 14: Admin status: false, level of admin status: false,
    // GSA status: true, allocation: true, rating: true
    fileNames[28] = 'CR014'
    // Configuration 15: Admin status: false, level of admin status: false,
    // GSA status: true, allocation: false, rating: true
    fileNames[20] = 'CR015'
    // Configuration 16: Admin status: false, level of admin status: false,
    // GSA status: true, allocation: true, rating: false
    fileNames[12] = 'CR016'
    // Configuration 17: Admin status: false, level of admin status: false,
    // GSA status: true, allocation: false, rating: false
    fileNames[4] = 'CR017'

    return fileNames
}

const GuestMenus = [
    {
        title: 'Administration',
        pathname: '/',
        authPrivilege: 'administration',
        userManagementMenus: [
            {
                title: 'Register for Full Access',
                icon: 'accountIcon',
                pathname: ENDPOINT.branchUserRegister,
                active: true,
                disable: false
            }
        ],
        tools: []
    }
]

export {getServiceBranchFileNames, getBranchFileNames, getCarrierFileNames, GuestMenus}
